// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23otZ","right":"styles_right__31QQR"};